import React, { ReactNode } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { RootState } from "../store"; // Replace with your actual store path

interface Props {
  children: ReactNode;
}

export default function AuthRoute({ children }: Props) {
  const user = useSelector((state: RootState) => state.user);
  const location = useLocation();
  if (user?.user?.userId) {
    return (
      <Navigate
        to={location?.state?.prevLoc ? location?.state?.prevLoc : "/"}
        replace
      />
    );
  }

  return <>{children}</>;
}
